import React from 'react';
import { usePortfolioContext } from './PortfolioContext';
import { cn } from '../../lib/utils';

interface PortfolioGroupListProps {
    onCreateClick: () => void;
}

export default function PortfolioGroupList({ onCreateClick }: PortfolioGroupListProps) {
    const { groups, selectedGroup, selectGroup } = usePortfolioContext();

    return (
        <div className="flex-1 overflow-auto p-2">
            <button
                onClick={onCreateClick}
                className="w-full flex items-center justify-center gap-1.5 px-3 py-2 mb-2 rounded-lg bg-primary text-white text-sm font-medium hover:bg-primary/90 transition-colors"
            >
                <span className="material-symbols-outlined text-[18px]">add</span>
                New Group
            </button>
            {groups.length === 0 ? (
                <div className="text-center py-8 text-slate-400">
                    <span className="material-symbols-outlined text-[40px] block mb-2">folder_open</span>
                    <p className="text-sm">No portfolio groups yet</p>
                    <button
                        onClick={onCreateClick}
                        className="mt-3 text-sm text-blue-600 hover:text-blue-700 font-medium"
                    >
                        Create your first group
                    </button>
                </div>
            ) : (
                <div className="space-y-1">
                    {groups.map((group) => (
                        <button
                            key={group.id}
                            onClick={() => selectGroup(group.id)}
                            className={cn(
                                'w-full text-left px-3 py-2.5 rounded-lg transition-colors',
                                selectedGroup?.id === group.id
                                    ? 'bg-blue-50 border border-blue-200 text-blue-900'
                                    : 'hover:bg-slate-50 text-slate-700'
                            )}
                        >
                            <div className="flex items-center justify-between">
                                <span className="font-medium text-sm truncate">{group.name}</span>
                                {group.is_any_stale && (
                                    <span className="w-2 h-2 rounded-full bg-amber-400 shrink-0 ml-2" title="Some assets are outdated" />
                                )}
                            </div>
                            <div className="flex items-center gap-2 mt-0.5">
                                <span className="text-xs text-slate-500">{group.asset_count} asset{group.asset_count !== 1 ? 's' : ''}</span>
                            </div>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
